import { isNaN } from './number';
export function isDate(val) {
  return Object.prototype.toString.call(val) === '[object Date]' && !isNaN(val.getTime());
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/validate/date.js
// module id = 349
// module chunks = 0